import React from 'react';

import { observer } from 'mobx-react';

import AddIcon from '@mui/icons-material/Add';

import { Button } from 'components/Button';

import { useStore } from 'utils/hooks/store';

import { canAddMembers, MEMBER_SEARCH_THRESHOLD } from 'containers/MemberGroups/utils/membership';
import { useMemberSearch } from 'containers/MemberGroups/utils/useMemberSearch';
import MemberSearchField from 'containers/MemberGroups/components/MemberSearchField';
import AddMembersModal from './AddMembersModal';
import GroupMemberTable from './GroupMemberTable';
import { MembersToolbar, Section, SectionHeader, SectionTitle } from './styles';

const MemberGroupMembersCard: React.FunctionComponent = observer(() => {
  const { memberGroupDetails } = useStore();
  const { group } = memberGroupDetails;
  const [addOpen, setAddOpen] = React.useState(false);
  const { searchQuery, temporaryFilters, onSearchChange } = useMemberSearch();

  if (!group) {
    return null;
  }

  const showSearch = group.memberCount >= MEMBER_SEARCH_THRESHOLD;

  return (
    <Section>
      <SectionHeader>
        <SectionTitle>Members · {group.memberCount}</SectionTitle>
        {canAddMembers(group) && (
          <Button
            size="medium"
            variant="outlined"
            startIcon={<AddIcon fontSize="small" />}
            onClick={() => setAddOpen(true)}
          >
            Add users
          </Button>
        )}
      </SectionHeader>
      <div>
        {showSearch && (
          <MembersToolbar>
            <MemberSearchField value={searchQuery} onChange={onSearchChange} />
          </MembersToolbar>
        )}
        <GroupMemberTable temporaryFilters={temporaryFilters} />
      </div>
      <AddMembersModal open={addOpen} onClose={() => setAddOpen(false)} />
    </Section>
  );
});

export default MemberGroupMembersCard;
